import { Field } from "formik";
import styled from "styled-components";
import { Color } from "../../theme/Color";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  showCounter?: boolean;
}

const StyledInput = styled.input<{ centered?: boolean }>`
  border: 1px solid ${Color.Grey7};
  text-align: ${(props) => (props.centered ? "center" : "left")};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const StyledFormikInput = styled(Field)<{ centered?: boolean }>`
  border: 1px solid ${Color.Grey7};
  text-align: ${(props) => (props.centered ? "center" : "left")};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const Input = ({
  showCounter = false,
  centered,
  ...props
}: InputProps & { centered?: boolean }) => {
  const value = props.value || "";
  const valueString = String(value);
  const count = valueString.length;
  const maxLength = props.maxLength;

  return (
    <>
      <StyledInput {...props} centered={centered} autoComplete="off" />
      {showCounter && maxLength && (
        <div style={{ textAlign: "right" }}>{`${count}/${maxLength}`}</div>
      )}
    </>
  );
};

export const FormikInput = (props) => {
  return <StyledFormikInput {...props} autoComplete="off" />;
};

export default Input;
